<template>
  <div class="col-12">
    <h3 class="fw-bold">{{ $t('cdb.subscriptions.tab_retention.title') }}</h3>
    <div class="card mb-3">
      <div class="card-body">
        <div class="d-flex flex-wrap">
          <div v-for="vehicle in vehicles" :key="vehicle.uuid" class="float-left">
            <div class="card m-3 shadow" style="width: 16rem;">
              <div class="row mt-3">
                <div class="col-12 col-md-6 offset-md-3">
                    <img 
                      class="card-img-top"
                      :src="vehicle.title_image.url"
                      :alt="`${vehicle.brand.title} ${vehicle.model.title}`"
                    >
                </div>
              </div>
              <div class="card-body p-3">
                <hr>
                <div>
                    <h5 class="card-title font-weight-bold mb-1 text-center">
                    {{ vehicle.brand.title }} {{ vehicle.model.title }}
                    </h5>
                    <h6 class="card-title small text-center">
                    {{ vehicle.description }}
                    </h6>
                </div>
                <hr>
                <div class="table-grid small">
                    <div class="row">
                      <div class="col">{{ $t('cat.filter.power') }}:</div>
                      <div class="col text-right">{{ vehicle.power.hp }} {{ $t('cat.product_tile.power.unit') }}</div>
                    </div>
                    <div class="row">
                      <div class="col">{{ $t('pds.fuel.title') }}:</div>
                      <div class="col text-right">{{ vehicle.fuel.title }}</div>
                    </div>
                    <div class="row">
                      <div class="col">{{ $t('cat.filter.gearshift') }}:</div>
                      <div class="col text-right">{{ vehicle.gearshift.title }}</div>
                    </div>
                    <div class="row">
                      <div class="col">{{ $t('cdb.price') }}:</div>
                      <div class="col text-right">{{ $t('cdb.from') }} {{ getLowestPricePlan(vehicle) }}</div>
                    </div>
                </div>
                <hr>
                <a 
                  class="btn btn-primary w-100" 
                  :href="getVehicleUrl(vehicle)"
                  target="_blank"
                >
                  Anzeigen
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleRecommendations',
  props: {
    subscriptionData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      vehicles: [],
    }
  },
  mounted() {
    this.fetchRecommendations();
  },
  methods: {
    async fetchRecommendations() {
      this.$axios.put(`api/v1/dashboard/get_recommendations`, {
        subscription_order_number: this.subscriptionData.order_number
      })
      .then(response => {
        this.vehicles = response.data
      }).catch(error => {
        alert($t('cdb.subscriptions.tab_subscription_extension.error_text'))
      });
    },
    getVehicleUrl(vehicle) {
      return `/katalog/${vehicle.slug}/${vehicle.uuid}?SID=${vehicle.subsidiary_uuid}`
    },
    getLowestPricePlan(vehicle) {
      const lowestPrice = Math.min(...vehicle.price_plans.map(o => o.price ))
      const pricePlan = vehicle.price_plans.find(o => o.price === lowestPrice);
      return pricePlan?.price + ' ' + pricePlan?.currency?.symbol;
    },
  }
}
</script>
